/**
 * 약관 동의용 커스텀 체크박스. `<input type="checkbox">` 대신 아이콘 두 개를 갈아 끼우는
 * 방식이라, 실제 체크 여부는 상위가 `checked`/`onClick`로 완전히 제어한다(제어 컴포넌트).
 */
import React from 'react';
import CheckedBox from '../icons/login/CheckedBox';
import UnCheckedbox from '../icons/login/UnCheckBox';

interface CheckboxProps {
  checked: boolean;
  onClick: () => void;
  /** 스크린리더가 읽을 항목 이름. 없으면 어떤 약관인지 알 수 없어 반드시 넘긴다. */
  label?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onClick, label }) => {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className="inline-flex items-center bg-transparent border-0 p-0 cursor-pointer"
    >
      {checked ? <CheckedBox /> : <UnCheckedbox />}
    </button>
  );
};

export default Checkbox;
